import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DPCustomer } from './dp-customer';
import { DPCustomerService } from './dp-customer.service';
import { DPRole } from './dp-role';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import { ToasterService } from 'angular2-toaster/src/toaster.service';

@Component({
    templateUrl: 'dp-customer-detail.component.html',
})
export class DPCustomerDetailComponent implements OnInit {
    @Input() customer: DPCustomer;
    @Output() close = new EventEmitter();
    error: any;
    navigated = false; // true if navigated here
    errorResponse: any;
    success: any;
    storedStatus: number;
    isStatusFirst: any;
    foundIt: any;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    submitting = false;


    constructor(
        private toasterService: ToasterService,

        private _service: NotificationsService,
        private router: Router,
        private customerSerivce: DPCustomerService,
        private route: ActivatedRoute) {
    }

    ngOnInit() {

        this.route.params.forEach((params: Params) => {
            const customer_id = +params['customer_id'];
            this.navigated = true;
            this.customerSerivce.getCustomer(customer_id)
                .then(customer => this.customer = customer);
        });
        this.isStatusFirst = true;
        this.storedStatus = 0;

    }
    errorHandler(error: any) {
        this.submitting = false;
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        const jsonErrorBody = JSON.parse(error._body);
        this.notificationContent = jsonErrorBody.error.message;
        this.createNotification();
    }
    save1(customer: DPCustomer, isValid: boolean) {
        // call API to save customer
        if (isValid == true) {
            this.submitting = true;
            //check role has been changed

            //check status has been changed
            if (this.isStatusFirst == false) {
                customer.status = this.storedStatus;
                customer.customer_id = this.customer.customer_id;
            } else {
                customer.status = this.customer.status;
                customer.customer_id = this.customer.customer_id;

            }
            //perform save
            this.save(customer);
        }
    }

    save(customer: DPCustomer) {
        this.customerSerivce
            .updateCustomer(customer)
            .then(customer => {
                this.customer = customer; // saved hero, w/ id if new
                this.goBack();
            })
            .catch(error => this.errorHandler(error));
    }
    goBack() {
        if (this.navigated) {
            event.stopPropagation();
            this.router.navigate(['/demandportal/customer']);

        }
    }
    public activeStatus = [
        { value: 0, display: 'Inactive' },
        { value: 1, display: 'Active' },
    ];



    checkExistingStatus() {
        if (this.customer.status == 1) {
            return true;
        }
        return false;
    }

    checkStatus() {
        if (this.isStatusFirst == true) {
            this.storedStatus = this.customer.status;
            this.isStatusFirst = false;
        }

        if (this.storedStatus == 0) {
            this.storedStatus = 1;
        }
        else {
            this.storedStatus = 0;
        }
    }
    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };


    createNotification() {
        switch (this.notificationType) {
            case 'success':
                //this._service.success(this.notificationTitle, this.notificationContent);
                this.toasterService.pop('success', this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this.toasterService.pop('error', this.notificationTitle, this.notificationContent);
                //this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this.toasterService.pop('info', this.notificationTitle, this.notificationContent);
                //this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/portalv1/dp-customer-detail.component.ts